import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 62px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AquiferDataAnalysisTool = () => {
  return (
    <>
      <Helmet title="Aquifer Data Analysis Tool" />

      <Container>
        <iframe
          src="https://aquiferapp.clearwater.lre-up.com/"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          title="Aquifer Data Analysis Tool"
        />
      </Container>
    </>
  );
};

export default AquiferDataAnalysisTool;
